// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__355zQ","author":"Table_author__TLkcX","authorImage":"Table_authorImage__1UXGQ","unreadRow":"Table_unreadRow__2z9aD"};